import { Pipe, PipeTransform } from '@angular/core';

import { UrlActionTrigger } from './url-action-trigger.types';

export function buildUrlActionTrigger<K extends keyof typeof UrlActionTrigger>(
  key: K,
  opt: string | null = null,
  skipHash: boolean = false,
) {
  let path = `${skipHash ? '' : '#/'}url-action-trigger/${UrlActionTrigger[key]}`;
  if (opt) path += `/${encodeURIComponent(opt)}`;
  return path;
}

@Pipe({
  pure: true,
  name: 'urlActionTrigger',
  standalone: true,
})
export class UrlActionTriggerPipe implements PipeTransform {
  public transform<K extends keyof typeof UrlActionTrigger>(key: K, opt?: string) {
    return buildUrlActionTrigger(key, opt);
  }
}
